import { UtilityProps } from '@gluestack-style/react/lib/typescript/types';
import { memo, useId } from 'react';
import { StyleProp, StyleSheet, View, ViewStyle } from 'react-native';

import Collapse, { CollapseProps } from 'components/Collapse';

type CollapseGroupProps = {
  items: CollapseProps[];
  gap?: UtilityProps<StyleProp<ViewStyle>>['gap'];
};

const CollapseGroup: React.FC<CollapseGroupProps> = ({ items, gap = '$2' }) => {
  const groupId = useId();
  // flexProp é sempre 1 para manter o comportamento original, pois breakpoints não existem nativamente
  const flexProp = 1;

  return (
    <View style={[styles.vStack, { flex: flexProp }]}>
      {items.map((item, index) => {
        const customKey = `${groupId}-${index}`;
        // Aplica espaçamento superior apenas a partir do segundo item
        const itemStyle = index > 0 ? { marginTop: gapToNumber(gap) } : undefined;
        return (
          <View key={customKey} style={itemStyle}>
            <Collapse {...item} />
          </View>
        );
      })}
    </View>
  );
};

const styles = StyleSheet.create({
  vStack: {
    flexDirection: 'column',
    width: '100%',
  },
});

// Função utilitária para converter gap em número (apenas para tokens conhecidos ou número direto)
function gapToNumber(gap: any): number {
  if (typeof gap === 'number') return gap;
  // Adapte conforme seus tokens de espaçamento
  const gapMap: Record<string, number> = {
    $px: 1,
    $0: 0,
    '$0.5': 2,
    $1: 4,
    '$1.5': 6,
    $2: 8,
    '$2.5': 10,
    $3: 12,
    '$3.5': 14,
    $4: 16,
    '$4.5': 18,
    $5: 20,
    $6: 24,
    $7: 28,
    $8: 32,
    $9: 36,
    $10: 40,
    $11: 44,
    $12: 48,
    $16: 64,
    $20: 80,
    $24: 96,
    $32: 128,
    $40: 160,
    $48: 192,
    $56: 224,
    $64: 256,
  };
  return gapMap[gap] ?? 8; // fallback para 8
}

export default memo(CollapseGroup);
